/**
 * 搜索 Hook
 * 支持搜索游戏和搜索建议
 */

import { useQuery } from '@tanstack/react-query';
import { searchAdapter } from '../adapters';
import type { GameSummary } from '../api/types';

/**
 * 搜索游戏（适配Search.tsx使用方式）
 */
export function useSearch(query: string) {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['search', query],
    queryFn: async () => {
      if (!query || query.length < 1) {
        return { games: [] as GameSummary[], total: 0 };
      }
      const result = await searchAdapter.search({ q: query, type: 'all' });
      return result.data;
    },
    enabled: query.length >= 1,
  });

  return {
    data: data?.games ?? [],
    isLoading,
    error,
    refetch,
    isDegraded: false, // 可以根据实际情况调整
  };
}

/**
 * 搜索建议
 * ⚠️ 降级：使用本地热门词
 */
export function useSearchSuggestions(input: string, limit?: number) {
  return useQuery({
    queryKey: ['suggestions', input, limit],
    queryFn: async () => {
      const result = await searchAdapter.getSuggestions(input);
      const suggestions = result.data;
      return limit ? suggestions.slice(0, limit) : suggestions;
    },
    enabled: input.length > 0,
  });
}

/**
 * 热门搜索词
 * ⚠️ 降级：使用本地配置
 */
export function useHotSearchTerms() {
  return useQuery({
    queryKey: ['hotSearchTerms'],
    queryFn: async () => {
      const result = await searchAdapter.getHotSearchTerms();
      return result;
    },
    staleTime: 60 * 60 * 1000, // 1小时缓存
  });
}
